import LoadingAnimatedIcon from './LoadingAnimatedIcon';

export default LoadingAnimatedIcon;
